import { Maybe } from "../api/types/generated-types";

export const formatUSD = (amount: Maybe<number> | undefined, formatOptions?: Intl.NumberFormatOptions): string => {
  const formatterUSD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", ...formatOptions });

  return formatterUSD.format(amount ?? 0);
};
